export default {
    containerStyles: {
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        my: '60px'
    },
    cardWrapper: {
        width: ['100%', '100%', '100%', '100%', '28%'],
        display: 'flex',
        flexDirection: ['column', null, null, null, 'row'],
        p: '1px',
        background: 'linear-gradient(180deg, #C6ECFD 0%, #0086C9 100%)',
        borderRadius: '12px',
        boxShadow: '0px 8px 20px 4px #41BEF60D, 0px 20px 24px -4px #004B8114',
        height: 'auto',
    },
    cardStyle: {
        position: 'relative',
        height: '365.6px',
        p: '28px',
        background: 'white',
        flexDirection: 'column',
        borderRadius: '12px',
        transition: 'all 0.3s',
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            cursor: 'pointer',
        },
    },
    imageWrapperStyles: {
        bg: '#f3f3f3',
        p: '10px',
        borderRadius: '12px',
    },
    textStyles: {
        title: {
            fontSize: '36px',
            fontWeight: 600,
            lineHeight: '54px',
            color: '#101828',
            mt: '60px',
            mb: '40px',
            textAlign: 'center',
        },
        subtitle: {
            fontSize: '20px',
            fontWeight: 600,
            lineHeight: '30px',
            color: '#101828',
            mb: '8px',
            mt: '20px',
            textAlign: 'left',
        },
        description: {
            fontSize: '18px',
            fontWeight: 400,
            lineHeight: '28px',
            color: '#475467',
            textAlign: 'left',
        },
    },
    linkStyles: {
        position: 'absolute',
        bottom: '20px',
        alignContent: 'center',
        justifyContent: 'left',
        mt: 3,
        fontSize: '16px',
        fontWeight: 600,
        color: '#0066cc',
    }
}